import React, { useRef, useState, useEffect } from "react";
import styled, { css } from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import Drawer from "../../common/Drawer";
import { Heading } from "../../../styles/component/style";
import CustomTable from "../../common/CustomTable/CustomTable";
import CaseService from "../../../services/CaseService";
import moment from "moment";
import queryString from "query-string";
import {
  getErrorMessage,
  parseTimeStamp,
  getFileFormat,
} from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import { makeStyles, Tooltip } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DrawerRecording from "../../internal/ViewRecordings/index";
import DocViewers from "./DocViewer";
import ViewKeywords from "./ViewExtract";
import AudioRecordings from "../MeetingAudioDetails/index";

const docTypes = [
  { ownerType: "claimant", title: "Claimant Documents" },
  { ownerType: "respondent", title: "Respondent Documents" },
  { ownerType: "common", title: "Neutral's Documents" },
];

async function getCaseDocument(id, query) {
  try {
    const response = await CaseService.getcaseDocuments(id, query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const Index = ({ state, setState, id, type, claimantId, respondentId }) => {
  return (
    <Drawer state={state} setState={setState} label="Drawer">
      <Table {...{ setState, id, type, claimantId, respondentId }} />
    </Drawer>
  );
};

export default Index;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#f9f9f9",
    border: "solid 0.5px #e1e3ee",
    boxShadow: "none",
    margin: "16px 0px 0px !important",
    "& .MuiAccordionSummary-content": {
      margin: "27px 0 27px 24px !important",
    },
    "& .MuiIconButton-root": {
      padding: 0,
      marginRight: 15,
      backgroundColor: "#fff",
    },
    "& .MuiSvgIcon-root": {
      fill: "#00838c",
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const Table = ({ setState, id, type, claimantId, respondentId }) => {
  const [urls, setUrls] = useState([]);
  const [trigger, setTrigger] = useState(false);

  const [expanded, setExpanded] = useState({});

  const handleAccordionChange = (ownerType) => (event, isExpanded) => {
    setExpanded((prev) => ({ ...prev, [ownerType]: isExpanded }));
  };

  const downloadFiles = async () => {
    try {
      const downloadPromises = urls.map(async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.download = url.substring(url.lastIndexOf("/") + 1);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      });
      await Promise.all(downloadPromises);
    } catch (error) {
      console.error("Error downloading files:", error);
    } finally {
      setTrigger(true);
      setUrls([]);
    }
  };

  return (
    <div>
      <Header>
        <Heading style={{ marginBottom: "unset", display: "flex" }}>
          Case Documents
          {urls.length ? (
            <Card>
              <div className="add_circle" onClick={downloadFiles}>
                <img
                  src={require("../../../assets/images/JustAct Icons Download-02.svg")}
                  alt="submit"
                />
              </div>
            </Card>
          ) : null}
        </Heading>
        <ImageWrapper>
          <img
            src={require("../../../assets/images/closeModal.svg")}
            onClick={() => {
              setState(false);
            }}
            alt="close"
          />
        </ImageWrapper>
      </Header>
      <AccordionContainer>
        {docTypes
          .filter((item) =>
            type === "negotiation" ? item.ownerType !== "mediator" : true
          )
          .map((item) => (
            <TableWithAccordion
              {...item}
              {...{
                id,
                claimantId,
                respondentId,
                setUrls,
                trigger,
                setTrigger,
              }}
              isExpanded={!!expanded[item.ownerType]}
              onAccordionChange={handleAccordionChange(item.ownerType)}
            />
          ))}
        {type !== "negotiation" ? (
          <DrawerRecording
            title="View Recordings"
            {...{ id, setState, type }}
          />
        ) : (
          ""
        )}
        {type !== "negotiation" ? <AudioRecordings {...{ id, type }} /> : null}
      </AccordionContainer>
    </div>
  );
};

function TableWithAccordion({
  id,
  title,
  ownerType,
  setUrls,
  trigger,
  setTrigger,
  isExpanded,
  onAccordionChange,
}) {
  const classes = useStyles();
  const [result, setResult] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const [docview, setDocView] = useState({ state: false });
  const [view, setView] = useState({ state: false });
  const MTRef = useRef();

  useEffect(() => {
    if (trigger && isExpanded && MTRef.current) {
      MTRef.current.onQueryChange(MTRef.current.state?.query || {});
      setTrigger(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, isExpanded]);

  const columns = [
    {
      field: "documentNo",
      title: "Doc ID",
      sorting: false,
      width: 100,
      headerStyle: {
        maxWidth: 100,
        width: 100,
        padding: `12px 16px`,
      },
      cellStyle: {
        maxWidth: 100,
        width: 100,
        padding: `12px 16px`,
      },
      render: (rowData) => (
        <HyperLink
          onClick={() => window.open(rowData.url?.url, rowData?.name)}
          style={{
            fontSize: 13,
            color: "#0084a3",
            textDecoration: "none",
          }}
        >
          {rowData.documentNo}
        </HyperLink>
      ),
    },
    {
      field: "url",
      title: "Document",
      sorting: false,
      width: 240,
      render: (rowData) => (
        <Tooltip
          title={
            rowData?.url?.url?.split("/").pop() ||
            rowData?.name ||
            "No filename"
          }
          placement="top"
          arrow
        >
          <div style={{ maxWidth: "100%" }}>
            <HyperLink
              onClick={(e) => {
                e.preventDefault();
                setDocView({
                  state: true,
                  url: rowData?.url?.url,
                  name: rowData?.name,
                  title: rowData?.entity?.title,
                  format: getFileFormat(rowData?.name),
                  pdf: rowData?.name.toLowerCase().endsWith(".pdf"),
                });
              }}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
                textDecoration: "none",
                fontWeight: 500,
                fontSize: 13,
              }}
            >
              {rowData?.name || "-"}
            </HyperLink>
          </div>
        </Tooltip>
      ),
    },
    {
      field: "owner.name",
      title: "Submitted By",
      sorting: false,
      width: 140,
      render: (rowData) => (
        <StyledTitle>{rowData?.owner?.name || "-"}</StyledTitle>
      ),
    },
    {
      field: "date",
      title: "Date",
      sorting: false,
      width: 140,
      render: (rowData) => (
        <div style={{ fontSize: 13, lineHeight: 1.5 }}>
          <StyledTitle>
            {rowData.created_at &&
              moment(parseTimeStamp(rowData.created_at)).format("DD/MM/YYYY")}
          </StyledTitle>
          <div style={{ color: "#888", fontSize: 11, marginTop: 2 }}>
            {rowData.created_at &&
              moment(parseTimeStamp(rowData.created_at)).format("hh:mm A")}
          </div>
        </div>
      ),
    },
    {
      field: "type",
      title: "Document Type",
      sorting: false,
      width: 210,
      render: (rowData) => {
        const type = rowData?.url?.uploadType || "Other";
        const colorMap = {
          Agreements: "#d32f2f",
          "Notices, Claims & Counterclaims": "#1976d2",
          "Evidence & Arguments": "#7c3aed",
          Petitions: "#ec407a",
          "Details of Proceedings": "#8b008b",
          "Orders & Minutes": "#2d5016",
          "Arbitration Notice": "#808000",
        };

        return (
          <Tooltip title={type} placement="top" arrow>
            <span
              title={type}
              style={{
                fontWeight: 600,
                fontSize: 12,
                color: colorMap[type] || "#293461",
                padding: "6px 10px",
                backgroundColor: (colorMap[type] || "#293461") + "15",
                borderRadius: 4,
                display: "inline-block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {type}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "extract",
      title: "Extract",
      sorting: false,
      width: 90,
      render: (rowData) =>
        rowData?.keywords?.length || rowData?.documentSummary ? (
          <HyperLink
            onClick={() =>
              setView({
                state: true,
                keywords: rowData?.keywords,
                documentSummary: rowData?.documentSummary,
              })
            }
            style={{
              color: "#0084a3",
              fontWeight: 600,
              fontSize: 13,
              textDecoration: "none",
            }}
          >
            View
          </HyperLink>
        ) : (
          <span style={{ color: "#ccc", fontSize: 13 }}>-</span>
        ),
      HeaderComponent: ExtractHeader,
      CellComponent: ExtractCell,
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let payload = {
        page: query.page + 1,
        perPage: 10,
      };
      if (ownerType) {
        if (ownerType === "claimant") {
          payload.claimantView = true;
        } else if (ownerType === "respondent") {
          payload.respondentView = true;
        } else {
          payload.commonView = true;
        }
      }
      const stringParams = `?${queryString.stringify(payload)}`;
      getCaseDocument(id, stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
            });
            setResult(result);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setResult({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  return (
    <>
      <Accordion
        className={classes.root}
        expanded={isExpanded}
        onChange={onAccordionChange}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <AccordionHeading>
            {title} {result?.total ? `(${result.total})` : ""}
          </AccordionHeading>
        </AccordionSummary>
        <AccordionDetails>
          {isExpanded && (
            <TableContainer>
              <CustomTable
                selection
                onSelectionChange={(selected) =>
                  setUrls(selected.map((item) => item?.url?.url))
                }
                pluralTitle="Documents"
                singularTitle=""
                {...{
                  columns,
                  data,
                  MTRef,
                }}
                noToolbar
                pageSize={10}
                hidePagination={result.lastPage === 1}
                state={result}
              />
            </TableContainer>
          )}
        </AccordionDetails>
      </Accordion>
      <ViewKeywords {...{ view, setView }} />
      <DocViewers {...{ docview, setDocView }} />
    </>
  );
}

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 40px;
  margin-top: 15px;
  border-bottom: 1px solid ${COLORS.BORDER_GREY};
`;
export const TableContainer = styled.div`
  /* margin: 30px 29px auto 38px; */
  width: 100%;
`;
export const AccordionHeading = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
`;

export const AccordionContainer = styled.div`
  padding: 0 20px;
`;

export const ImageWrapper = styled.div`
  cursor: pointer;
`;
export const HyperLink = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.BTN_GREEN};
  text-decoration: underline;
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : "0px")};
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledTitle = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  min-width: 100px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65%;
  margin: 0 auto;
  @media (min-width) {
    justify-content: space-between;
  }
`;

export const CheckedIconContainer = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Card = styled.div`
  width: 32px;
  display: flex;
  border-radius: 7px;
  align-items: center;
  justify-content: space-between;
  margin-left: 10px;
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.6;
      & .add_circle {
        cursor: not-allowed !important;
      }
    `}

  & .add_circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 23px;
    height: 23px;
    border-radius: 100%;
    cursor: pointer;
    background-color: rgba(0, 131, 140, 0.13);
  }
  & .add_icon {
    color: ${COLORS.BTN_GREEN};
    font-size: 18px;
  }
`;

const HeaderCell = styled.th`
  padding: 14px 16px !important;
  background-color: #1a2547 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-align: ${(props) => props.align || "left"} !important;
  border-bottom: 2px solid #0f1935 !important;
  letter-spacing: 0.5px !important;
`;

const BodyCell = styled.td`
  padding: 14px 16px !important;
  text-align: ${(props) => props.align || "left"} !important;
  vertical-align: middle !important;
  border-bottom: 1px solid #e8ecf1 !important;
  font-size: 13px !important;
`;

const ExtractHeader = styled(HeaderCell)`
  text-align: center !important;
`;

const ExtractCell = styled(BodyCell)`
  text-align: center !important;
`;
